import clsx from "clsx";
import { FormFieldComponentProps } from "./types";

export default function EmailField({
  id,
  label,
  required,
  value,
  error,
  onChange,
}: FormFieldComponentProps) {
  return (
    <div className={clsx("field", error && "invalid")}>
      <label htmlFor={id} className="label">
        {label}
        {required && " *"}
      </label>
      <input
        id={id}
        name={id}
        type="email"
        autoComplete="email"
        required={required}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className="value"
      />
      {error && (
        <p id={`${id}-error`} role="alert" className="error">
          • {error}
        </p>
      )}
    </div>
  );
}
